import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: false,
  selector: 'button[app-add-button]',
  template: `
    <i *ngIf="icon" [class]="icon" [ngClass]="{'mr-2': label}"></i>
    <span *ngIf="label">{{ label }}</span>
  `,
  styles: [`
    .mr-2 { margin-right: 8px; }
  `],
  encapsulation: ViewEncapsulation.None
})
export class AddButtonComponent {
  @Input() label: string = ''; 
  @Input() icon: string = 'pi pi-plus';
}